import type { CaboTipo } from '../../../services/caboService';

type CablePolylineInput = {
  points: google.maps.LatLngLiteral[];
  color: string;
  tipo?: CaboTipo | null;
  strokeWeight?: number;
  clickable?: boolean;
  zIndex?: number;
};

export function buildCablePolylineOptions({
  points,
  color,
  tipo,
  strokeWeight = 3,
  clickable = true,
  zIndex = 100,
}: CablePolylineInput): google.maps.PolylineOptions {
  const base: google.maps.PolylineOptions = {
    path: points,
    geodesic: true,
    strokeColor: color,
    strokeOpacity: 1,
    strokeWeight,
    editable: false,
    draggable: false,
    clickable,
    zIndex,
  };

  if (tipo === 'drop') {
    return {
      ...base,
      strokeOpacity: 0,
      icons: [
        {
          icon: {
            path: 'M 0,-1 0,1',
            strokeOpacity: 1,
            strokeColor: color,
            scale: 4,
          },
          offset: '0',
          repeat: '16px',
        },
      ],
    };
  }

  return base;
}

const CABLE_SELECTION_OUTLINE_COLOR = '#FF9800';

export function buildCableSelectionOutlineOptions({
  points,
  tipo,
  zIndex = 99,
}: Pick<CablePolylineInput, 'points' | 'tipo'> & { zIndex?: number }): google.maps.PolylineOptions {
  const base: google.maps.PolylineOptions = {
    path: points,
    geodesic: true,
    strokeColor: CABLE_SELECTION_OUTLINE_COLOR,
    strokeOpacity: 1,
    strokeWeight: 7,
    editable: false,
    draggable: false,
    clickable: false,
    zIndex,
  };

  if (tipo === 'drop') {
    return {
      ...base,
      strokeOpacity: 0,
      icons: [
        {
          icon: {
            path: 'M 0,-1 0,1',
            strokeOpacity: 1,
            strokeColor: CABLE_SELECTION_OUTLINE_COLOR,
            scale: 5,
          },
          offset: '0',
          repeat: '16px',
        },
      ],
    };
  }

  return base;
}
